import { FC, memo, useEffect, useState } from "react";
import classNames from "classnames";
import { twMerge } from "tailwind-merge";

import Button from "@/common/Button";
import { logAnalyticsEvent } from "@/constants/amplitude";
import { WebEventProps, WebEventTypes } from "@/constants/event";
import { HandleContinue, HandleNext } from "@/types/common";
import { Question } from "@/types/question";
import useAnswers from "@/utils/useAnswers";

interface PromoScreenProps {
    question: Question;
    handleNext: HandleNext | HandleContinue;
    isActive: boolean;
}

export const PromoScreen: FC<PromoScreenProps> = memo(
    ({
        handleNext,
        question: {
            event,
            containerClassName,
            content,
            btnClassName,
            groupTitle,
            buttonDelay,
            buttonText = "Continue",
        },
        isActive,
    }) => {
        const [infoVisibilityClass, setInfoVisibilityClass] = useState(
            buttonDelay ? "opacity-0" : ""
        );

        const { answers } = useAnswers();

        useEffect(() => {
            if (isActive && buttonDelay) {
                setTimeout(() => {
                    setInfoVisibilityClass("opacity-100");
                }, buttonDelay);
            } else {
                setInfoVisibilityClass(buttonDelay ? "opacity-0" : "");
            }
        }, [isActive, buttonDelay]);

        const handleContinue = () => {
            logAnalyticsEvent(WebEventTypes.RESULT_EVENT, {
                [WebEventProps.SCREEN]: event,
            });
            handleNext();
        };

        return (
            <div
                className={classNames(
                    "flex h-full w-full grow flex-col content-between gap-10 bg-cover bg-center py-10 text-black",
                    containerClassName,
                    { "zing-screen": !groupTitle }
                )}
            >
                {content && content({ answers, isActive })}
                <Button
                    className={twMerge(
                        classNames(
                            "bg-black transition-opacity female:bg-white female:text-black",
                            btnClassName,
                            infoVisibilityClass
                        )
                    )}
                    onClick={handleContinue}
                >
                    {buttonText}
                </Button>
            </div>
        );
    }
);
